module.exports = __webpack_public_path__ + "static/media/agent2.0e236107.jpg";